import { Checkbox, Col, DatePicker, Input, Radio, RadioChangeEvent, Row, Select, Space, Table } from "antd";
import ColumnGroup from "antd/lib/table/ColumnGroup";
import Column from "antd/lib/table/Column";
import moment from "moment";

import { ISuitabilityTestQCF } from "./ISuitabiltyTestQCF";
import { Record8 } from "../../../Models/SuitabilityTest";

import './SuitabilityTest.scss';

const {Option} = Select;

const SuitabilityTestQCF = ({
	translations,
	investorInfo,
	errors,
	isSuitabilityDone,
	testResponses,
	onQuestionAnswered,
	getQ4Title,
	isReadOnly = false,
}: ISuitabilityTestQCF) => {
	return (
		<Col span={24}>
			<Row gutter={[16, 16]} className="info">
				<strong>{translations.suitability_title1}</strong>
				<ol>
					<li>{translations.suitability_p1}</li>
					<li>{translations.suitability_p2}</li>
					<li>{translations.suitability_p3}</li>
					<li>{translations.suitability_p4}</li>
				</ol>
			</Row>
			<Row gutter={[16, 16]} className="test">
				<Col span="6" className="titles">
					<label className="required"> {translations.nombre}</label>
					<Input
						type="text"
						className="input-field"
						name="name"
						value={investorInfo.name!}
						disabled
						status={errors.name ? 'error' : ''}
					/>
				</Col>
				<Col span="6" className="titles">
					<label className="required"> {translations.firstLastnameSignatory}</label>
					<Input
						type="text"
						className="input-field"
						name="surname"
						value={investorInfo.surname!}
						disabled
						status={errors.surname ? 'error' : ''}
					/>
				</Col>
				<Col span="6" className="titles">
					<label className="required"> {translations.birthDate}</label>
					<DatePicker
						className="input-field"
						name="birthDate"
						value={investorInfo.birthDate ? moment(investorInfo.birthDate) : undefined}
						format="DD/MM/YYYY"
						disabled
						status={errors.birthDate ? 'error' : ''}
					/>
				</Col>
				<Col span="6" className="titles">
					<label className="required"> {translations.documentNumber}</label>
					<Input
						type="text"
						className="input-field"
						name="dni"
						value={investorInfo.dni}
						disabled
						status={errors.dni ? 'error' : ''}
					/>
				</Col>
				<Col span="6" className="titles">
					<label className="required"> {translations.completionDate}</label>
					<DatePicker
						className="input-field"
						name="dateOfCompletion"
						value={testResponses.dateOfCompletion ? moment(testResponses.dateOfCompletion) : undefined}
						format="DD/MM/YYYY"
						onChange={(date) => onQuestionAnswered('dateOfCompletion')(date ? date.format("YYYY-MM-DD") : null)}
						disabled={isSuitabilityDone || isReadOnly}
						status={errors.dateOfCompletion ? 'error' : ''}
					/>
				</Col>
				<Col span="24" className="titles">
					<strong>{translations.suitability_q1}</strong>
					<span className={`error ${errors.Q1 ? 'show' : null}`}>{translations.completeCampo}</span>
					<Checkbox 
						disabled={isSuitabilityDone || isReadOnly}
						onChange={(e:any) => onQuestionAnswered('q1_1')(e.target.checked)}
						checked={testResponses.q1_1 ?? false}>{translations.suitability_q1_01}
					</Checkbox> 
					<br />
					<Checkbox
						disabled={isSuitabilityDone || isReadOnly}
						onChange={(e:any) => onQuestionAnswered('q1_2')(e.target.checked)}
						checked={testResponses.q1_2 ?? false}>{translations.suitability_q1_02}
					</Checkbox>
					<br />
					<Checkbox
						disabled={isSuitabilityDone || isReadOnly}
						onChange={(e:any) => onQuestionAnswered('q1_3')(e.target.checked)}
						checked={testResponses.q1_3 ?? false}>{translations.suitability_q1_03}
					</Checkbox>
					<Checkbox
						disabled={isSuitabilityDone || isReadOnly}
						onChange={(e:any) => onQuestionAnswered('q1_4')(e.target.checked)}
						checked={testResponses.q1_4 ?? false}>{translations.suitability_q1_04}
					</Checkbox>
					<Checkbox
						disabled={isSuitabilityDone || isReadOnly}
						onChange={(e:any) => onQuestionAnswered('q1_5')(e.target.checked)}
						checked={testResponses.q1_5 ?? false}>{translations.suitability_q1_05}
					</Checkbox>
				</Col>
				<Col span="24" className="titles">
					<strong>{translations.suitability_q2}</strong>
					<span className={`error ${errors.Q2 ? 'show' : null}`}>{translations.completeCampo}</span>
					<Radio.Group
						onChange={(e:RadioChangeEvent) => onQuestionAnswered('q2')(e.target.value)}
						disabled={isSuitabilityDone || isReadOnly}
						value={testResponses.q2}>
						<Space direction="vertical">
							<Radio value={1}>{translations.suitability_q2_01}</Radio>
							<Radio value={2}>{translations.suitability_q2_02}</Radio>
							<Radio value={3}>{translations.suitability_q2_03}</Radio>
							<Radio value={4}>{translations.suitability_q2_04}</Radio>
						</Space>
					</Radio.Group>
				</Col>
				<Col span="24" className="titles">
					<strong>{translations.suitability_q3}</strong>
					<span className={`error ${errors.Q3 ? 'show' : null}`}>{translations.completeCampo}</span>
					<Radio.Group
						onChange={(e:RadioChangeEvent) => onQuestionAnswered('q3')(e.target.value)}
						disabled={isSuitabilityDone || isReadOnly}
						value={testResponses.q3}
					> 
						<Space direction="vertical">
							<Radio value={1}>{translations.suitability_q3_01}</Radio>
							<Radio value={2}>{translations.suitability_q3_02}</Radio>
							<Radio value={3}>{translations.suitability_q3_03}</Radio>
						</Space>
					</Radio.Group>
				</Col>
				<Col span="24" className="titles">
					<strong>{getQ4Title()}</strong>
					<span className={`error ${errors.Q4 ? 'show' : null}`}>{translations.completeCampo}</span>
					<Radio.Group
						onChange={(e:RadioChangeEvent) => onQuestionAnswered('q4')(e.target.value)}
						disabled={isSuitabilityDone || isReadOnly}
						value={testResponses.q4}
					>
						<Space direction="vertical">
							<Radio value={1}>{translations.suitability_q4_01_continuation_finance}</Radio>
							<Radio value={2}>{translations.suitability_q4_02_continuation_finance}</Radio>
							<Radio value={3}>{translations.suitability_q4_03_continuation_finance}</Radio>
							<Radio value={4}>{translations.suitability_q4_04_continuation_finance}</Radio>
						</Space>
					</Radio.Group>
				</Col>
				<Col span="24" className="titles">
					<strong>{translations.suitability_q5}</strong>
					<span className={`error ${errors.Q5 ? 'show' : null}`}>{translations.completeCampo}</span>
					<Radio.Group
						onChange={(e:RadioChangeEvent) => onQuestionAnswered('q5')(e.target.value)}
						disabled={isSuitabilityDone || isReadOnly}
						value={testResponses.q5}
					>
						<Space direction="vertical">
							<Radio value={1}>{translations.suitability_q5_01}</Radio>
							<Radio value={2}>{translations.suitability_q5_02}</Radio>
							<Radio value={3}>{translations.suitability_q5_03}</Radio>
						</Space>
					</Radio.Group>
				</Col>
				<Col span="24" className="titles">
					<strong>{translations.suitability_q6}</strong>
					<span className={`error ${errors.Q6 ? 'show' : null}`}>{translations.completeCampo}</span>
					<Radio.Group
						onChange={(e:RadioChangeEvent) => onQuestionAnswered('q6')(e.target.value)}
						disabled={isSuitabilityDone || isReadOnly}
						value={testResponses.q6}
					>
						<Space direction="vertical">
							<Radio value={1}>{translations.suitability_q6_01}</Radio>
							<Radio value={2}>{translations.suitability_q6_02}</Radio>
							<Radio value={3}>{translations.suitability_q6_03}</Radio>
						</Space>
					</Radio.Group>
				</Col>
				<Col span="24" className="titles">
					<strong>{translations.suitability_q7}</strong>
					<span className={`error ${errors.Q7 ? 'show' : null}`}>{translations.completeCampo}</span>
					<Radio.Group
						onChange={(e:RadioChangeEvent) => onQuestionAnswered('q7')(e.target.value)}
						disabled={isSuitabilityDone || isReadOnly}
						value={testResponses.q7}
					>
						<Space direction="vertical">
							<Radio value={1}>{translations.suitability_q7_01}</Radio>
							<Radio value={2}>{translations.suitability_q7_02}</Radio>
							<Radio value={3}>{translations.suitability_q7_03}</Radio>
						</Space>
					</Radio.Group>
				</Col>
				<Col span="24" className="titles">
					<strong>{translations.suitability_q8}</strong>
					<Table
						className="table"
						pagination={false}
						dataSource={[
							{
								key: '0',
								tool: translations.suitability_q8_01,
								ops: 'q8_1_Ops',
								vol: 'q8_1_Vol',
								questionNumber: '1'
							},
							{
								key: '1',
								tool: translations.suitability_q8_02,
								ops: 'q8_2_Ops',
								vol: 'q8_2_Vol',
								questionNumber: '2'
							},
							{
								key: '2',
								tool: translations.suitability_q8_03,
								ops: 'q8_3_Ops',
								vol: 'q8_3_Vol',
								questionNumber: '3'
							},
							{
								key: '3',
								tool: translations.suitability_q8_04,
								ops: 'q8_4_Ops',
								vol: 'q8_4_Vol',
								questionNumber: '4'
							},
							{
								key: '4',
								tool: translations.suitability_q8_05,
								ops: 'q8_5_Ops',
								vol: 'q8_5_Vol',
								questionNumber: '5'
							},
							{
								key: '5',
								tool: translations.suitability_q8_06,
								ops: 'q8_6_Ops',
								vol: 'q8_6_Vol',
								questionNumber: '6'
							}
						]}
					>
						<Column title="Instrumento" dataIndex="tool" key="tool"/>
						<ColumnGroup title={translations.volumeOp}>
							<Column title={translations.qOps} dataIndex="1" key="01" render={(_: any, record: Record8) => (
								<Select
									style={{width: '100%'}}
									onChange={(e) => onQuestionAnswered(record.ops)(e)}
									placeholder="Select one option"
									value={testResponses[record.ops]} 
									disabled={isSuitabilityDone || isReadOnly}
									status={errors[record.ops] ? 'error' : ''}
								>
									<Option key="01" value={1}>{translations.suitability_q8_lessThan2}</Option>
									<Option key="02" value={2}>{translations.suitability_q8_moreThan2}</Option>
									<Option key="03" value={3}>{translations.suitability_q8_none}</Option>
								</Select>
							)}

								/>
							<Column title={translations.vOps} dataIndex="2" key="02"  render={(_: any, record: Record8) => (
								<Select
									style={{width: '100%'}}
									onChange={(e) => onQuestionAnswered(record.vol)(e)}
									value={testResponses[record.vol]} 
									disabled={isSuitabilityDone || isReadOnly || testResponses[record.ops] === 3}
									status={errors[record.vol] ? 'error' : ''}
								>
									<Option key="04" value={1}>{translations.suitability_q8_lessThan25k}</Option>
									<Option key="05" value={2}>{translations.suitability_q8_lessThan150k}</Option>
									<Option key="06" value={3}>{translations.suitability_q8_lessThan500k}</Option>
									<Option key="07" value={4}>{translations.suitability_q8_moreThan500k}</Option>
								</Select>
							)}/>
						</ColumnGroup>
					</Table>
				</Col>
				<Col span="24" className="titles">
					<strong>{translations.suitability_q9}</strong>
					<span className={`error ${errors.Q9 ? 'show' : null}`}>{translations.completeCampo}</span>
					<Radio.Group
						onChange={(e:RadioChangeEvent) => onQuestionAnswered('q9')(e.target.value)}
						disabled={isSuitabilityDone || isReadOnly}
						value={testResponses.q9}
					>
						<Space direction="vertical">
							<Radio value={1}>{translations.suitability_q9_01}</Radio>
							<Radio value={2}>{translations.suitability_q9_02}</Radio>
							<Radio value={3}>{translations.suitability_q9_03}</Radio>
						</Space>
					</Radio.Group>
				</Col>
			</Row>
		</Col>
	);
};

export default SuitabilityTestQCF;
